import {localTimeFormat} from 'common/formats';
import dayjs from 'dayjs';
import {isDate, isNull, isString} from 'lodash';
import {DateSchema, mixed, string} from 'yup';
import {CONTEXT_SEND_PARAMETER} from '../constants';
import customParseFormat from 'dayjs/plugin/customParseFormat';
dayjs.extend(customParseFormat);

export const localTimeNullable = () =>
   mixed().when(CONTEXT_SEND_PARAMETER, {
      is: true,
      then: string().transform(function (val, origin) {
         // console.debug(val, origin);
         if (isString(val) && val.length === localTimeFormat.length) {
            return val;
         }

         const day = dayjs(origin);
         if (!day.isValid()) return null;

         return day.format(localTimeFormat);
      }),
      otherwise: mixed().transform(function (val, origin) {
         if (isDate(val) && dayjs(val).isValid()) {
            return val;
         }
         const time = isNull(origin) ? null : dayjs(origin, localTimeFormat).toDate();

         // console.debug(time, localTimeFormat);
         return time;
      }),
   }) as DateSchema<Date>;
